import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Tooltip } from 'antd';
//@ts-ignore
import { SensorSelect } from 'farmx-web-ui';
import { isMobile } from 'utils/detectDevice';
import { FORM_RULES } from '../../../constants';
import './ruleSettingsPage.less';

interface SensorControlProps {
  sensor: any;
  form: object | any;
  setSelectedSensor: any;
  formName?: any;
  formLabel?: any;
  sensorTypes?: any;
  selectedRanch?: number;
  selectedBlock?: number;
  prefix?: string;
  fullWidth?: boolean;
}

const SensorControl: React.FC<SensorControlProps> = (props: any) => {
  const {
    sensor, form, setSelectedSensor, formName, formLabel,
    sensorTypes, selectedRanch, prefix, fullWidth
  } = props;
  const { t } = useTranslation();
  const rules = FORM_RULES(t);
  const { requiredSensorField } = rules;
  // When sensor control and depth control are in same row
  const specialStyleCase = (formName === 'irrigation' && isMobile) ? 'width-75' : 'width-100';

  return (
    <Form.Item
      label={<Tooltip title={t(formLabel || 'Reference Soil Moisture Sensor')}>
        <span className="ellipsis-label">
          {t(formLabel || 'Reference Soil Moisture Sensor')}
        </span>
      </Tooltip>}
      name={formName || 'sensor'}
      rules={requiredSensorField}
      className={`font-bold ${isMobile && !fullWidth ? 'width-75-percent' : 'width-100'}`}
    >
      <SensorSelect
        sensorTypeConstraint={sensorTypes || ['pixl_soil']}
        selectedFilters={selectedRanch && [{
          type: 'ranch', value: selectedRanch, op: 'AND', noEdit: false, noDelete: false
        }]}
        sensorType={sensor?.[`${prefix}reference_sensor_type`]}
        sensorIdentifier={sensor?.[`${prefix}reference_sensor_identifier`]}
        sensorId={sensor?.[`${prefix}reference_sensor_id`]}
        onChange={(d: any) => {
          const sensorControl = {
            [`${prefix}reference_sensor_id`]: d?.id,
            [`${prefix}reference_sensor_type`]: d?.type,
            [`${prefix}reference_sensor_identifier`]: d?.identifier
          };
          if (formName) {
            form.setFieldsValue({ [formName]: d?.id ? sensorControl : undefined });
          } else {
            // eslint-disable-next-line react/prop-types
            form.setFieldsValue({ sensor: d?.id ? sensorControl : undefined });
            form.setFieldsValue({ refill_point_depth: undefined });
            form.setFieldsValue({ stopping_point_depth: undefined });
          }
          if(formName?.includes('irrigation')) {
            form.setFieldsValue({ depth: undefined });
          }
          if (formName?.includes('sprinkler')) {
            form.setFieldsValue({ sprinklerDepth: undefined });
          }
          setSelectedSensor(sensorControl);
        }}
      />
    </Form.Item>
  );
};

SensorControl.defaultProps = {
  prefix: '',
  fullWidth: true,
};

export default SensorControl;
